import React from 'react';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import style from './styles.module.scss';

export default function showProductMessage(text, path = "/cart") {
  const ToastContent = ({ closeToast }) => {
    const navigate = useNavigate();

    const handleGoToCart = () => {
      navigate(path);
      closeToast();
    };

    return (
      <div className={style.toast}>
        <p>{text}</p>
        <div className={style.toastButtons}>
          <button className={style.toastButtonSuccess} onClick={handleGoToCart}>
            Sepete Git
          </button>
          <button className={style.toastButtonCancel} onClick={closeToast}>
            Alışverişe Devam Et
          </button>
        </div>
      </div>
    );
  };

  toast.success(<ToastContent />, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false,
  });
}
